module.exports = __webpack_public_path__ + "static/media/style.80212289.sass";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/PhaseMain/style.sass
// module id = 1125
// module chunks = 0